<template>
  <div>
    <Breadcrumb :options="breadcrumb" />
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSearchChange">
        </CompositeFormDate>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showIndex="true"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />

    <div class="overlay" v-show="showImg">
      <div class="close" @click="showImg = false"></div>
      <img class="img" :src="previewurl">
    </div>

    <div class="printview">
      <img class="img" id="pdfcont" :src="previewurl">
    </div>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import { mapState, mapMutations } from "vuex";
import downL from '../cont/pdf'

export default {
  mixins: [tableMixin, downL],
  data() {
    return {
      baseUrl: "agreement",
      getListUrl: 'record',
      breadcrumb: [
        { name: "人员管理", path: `/staff/escort` },
        { name: "押运管理", path: `/staff/escort` },
        { name: "签约管理" },
      ],
      baseParams: ['user_id'],
      searchDateOptions: [
        {
          label: "签订时间",
          keyName: "start_at",
          type: "date",
        },
        {
          label: "到期时间",
          keyName: "end_at",
          type: "date",
        }
      ],
      formInline: {},
      cols: [
        { prop: "license", label: "车牌号" },
        { prop: "name", label: "姓名" },
        { prop: "type_name", label: "合约名称" },
        { prop: "start_at", label: "签订时间" },
        { prop: "end_at", label: "到期时间" },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ agreement_file }) => {
            console.log(agreement_file)
            this.previewurl = agreement_file
            this.showImg = true
          },
        },
        {
          title: '下载',
          img: require('@/assets/img/icon_xz.png'),
          unimg: require('@/assets/img/icon_xz_hover.png'),
          cb: ({ agreement_file, type_name, name, height, total_pages }) => {
            this.previewurl = agreement_file
            // this.previewurl = 'https://xlimage.uzero.cn/shinescan/res/shinescanicon.png'
            setTimeout(() => {
              const pdfContentEl = document.getElementById('pdfcont');
              const str = `${name}_${type_name}${(new Date()).getTime()}.pdf`
              this.downLoadPDF(pdfContentEl, str, height, total_pages)
            }, 500)
          },
        },
      ],
      showImg: false,
      previewurl: '',
    };
  },
  computed: {
    ...mapState(["store"]),
  },
  methods: {
    ...mapMutations(["setState"]),
  },
  mounted() {
    this.formInline.user_id = this.$route.query.id
    this.getList()
  },
};
</script>

<style lang="less" scoped>
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  z-index: 2001;
  background: rgba(0, 0, 0, .3);
  text-align: center;

  .close {
    position: fixed;
    right: 50px;
    top: 30px;
    width: 50px;
    /* 可以根据需要调整大小 */
    height: 50px;
    cursor: pointer;
    background: rgba(0, 0, 0, .6);
    border-radius: 50%;

    &::before,
    &::after {
      content: '';
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 2px;
      /* 线条的宽度 */
      height: 30px;
      /* 线条的长度，为图标大小的一半 */
      background-color: white;
      /* 线条的颜色 */
      transform: translate(-50%, -50%) rotate(45deg);
      transition: all 0.3s;
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }

  }
}

.printview {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  min-height: 100vh;
  overflow: auto;
  z-index: -100;

  .img {
    width: auto;
  }
}
</style>
